<template>
    <div>
        <v-content>
            <nav class="navbar is-transparent">
                <div class="navbar-brand">
                    <router-link to="/">
                        <div class="header__Logo">
                            <div class="header__Logo-element">
                                <img :src="logoSrc" alt=""/>
                            </div>
                            <div class="header__Logo-element header__Logo-element-text">
                                <span class="header__Logo-text header__Logo-text-bold">
                                 Mizaem
                                </span>

                                <span class="header__Logo-text header__Logo-text-thin">
                                 Сервис отправки сообщений
                                </span>
                            </div>
                        </div>
                    </router-link>
                    <div
                        role="button"
                        class="navbar-burger burger"
                        aria-label="menu"
                        aria-expanded="false"
                        @click="isOpen = !isOpen"
                        v-bind:class="{ 'is-active': isOpen }"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div class="navbar-menu" v-bind:class="{ 'is-active': isOpen }" v-if="isLoggedIn">
                    <div class="navbar-end">
                        <router-link class="navbar-item" to="/users">
                            Пользователи
                        </router-link>
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                Оповещения
                            </a>
                            <div class="navbar-dropdown">
                                <router-link class="navbar-item" to="/instant-notifications">
                                    Отправка оповещений
                                </router-link>
                                <router-link class="navbar-item" to="/notification-settings">
                                    Цепочка оповещений
                                </router-link>
                                <hr class="navbar-divider" />
                                <router-link class="navbar-item" to="/call-templates">
                                    Шаблоны голосовых рассылок(Звонобот)
                                </router-link>
                                <router-link class="navbar-item" to="/templates">
                                    Шаблоны рассылок
                                </router-link>
                                <router-link class="navbar-item" to="/audio-list">
                                    Список аудиозаписей
                                </router-link>
                                <router-link class="navbar-item" to="/outgoing-phones">
                                    Список телефонов
                                </router-link>
                                <hr class="navbar-divider" />
                                <router-link class="navbar-item" to="/deliveries">
                                    Список рассылок
                                </router-link>
                                <router-link
                                    class="navbar-item"
                                    to="/notification-statistics"
                                >
                                    Статистика оповещений
                                </router-link>
                            </div>
                        </div>
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                Настройки
                            </a>
                            <div class="navbar-dropdown">
                                <router-link class="navbar-item" to="/settings">
                                    Настройки
                                </router-link>
                                <router-link class="navbar-item" to="/account-mailers">
                                    Аккаунты рассыльщиков
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="navbar-item">
                        <div class="field is-grouped is-pulled-right">
                            <v-btn @click="logout()" depressed color="primary">
                                Выйти
                                <v-icon right dark>mdi-logout</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </nav>
        </v-content>
    </div>
</template>

<script>
export default {
    name: "Header",
    data() {
        return {
            logoSrc: "../logo/mizaem-small-logo.png",
            isOpen: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.IS_LOGGED_IN;
        },
    },
    methods: {
        logout() {
            this.$store.dispatch("LOGOUT").then(() => {
                this.$router.push("/admin-login");
            });
        },
    },
};
</script>

<style>
.navbar {
    background-color: #ffffff;
    border-bottom: solid 1px #e4e4e4;
}

.navbar-menu a {
    color: #585858 !important;
}

.navbar-menu a:hover {
    color: #2196f3 !important;
}

.header__Logo-element img {
    max-height: 3.75rem;
}

.header__Logo {
    margin-left: 20px;
    padding: 5px;
}

.header__Logo-element {
    display: inline-block;
    line-height: 22px;
    vertical-align: middle;
}

.header__Logo-element-text {
    margin-left: 5px;
}

.header__Logo-text {
    display: block;
    text-align: left;
    font-weight: 400;
    padding: 0;
    margin: 0;
    text-decoration: none;
    text-underline: none;
    color: #4a4a4a;
}

.header__Logo-text-bold {
    font-size: 30px;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
}

.header__Logo-text-thin {
    color: #292929;
}

@media (max-width: 600px) {
    .header__Logo-element img {
        max-height: 2.75rem;
    }

    .header__Logo-text-thin {
        font-size: 14px !important;
    }

    .header__Logo-text-bold {
        font-size: 24px !important;
    }

    .navbar-brand {
        margin-top: 5px;
    }
}
</style>
